import { useSelector } from "react-redux";
import { resolveSportType } from "src/utils/formatSportType";

export default function useTenantSportType(sportType) {
  const selectedTenant = useSelector((state) => state.tenant.selectedTenant);
  return resolveSportType(sportType ?? selectedTenant?.sportType);
}
